/**
 * Per-organization record that the Terms of Service screen failed to load and
 * the user was let through anyway. Scoped to the browser session, so a fresh
 * tab asks again. Every sessionStorage access is guarded: blocked storage
 * reads as "not bypassed" and never throws.
 */

export const TOS_BYPASS_KEY_PREFIX = "tosViewBypassedDueToLoadError:";

const bypassKey = (orgId: string): string => `${TOS_BYPASS_KEY_PREFIX}${orgId}`;

export const isTosViewBypassed = (orgId: string): boolean => {
  try {
    return window.sessionStorage.getItem(bypassKey(orgId)) === "true";
  } catch {
    return false;
  }
};

export const markTosViewBypassed = (orgId: string): void => {
  try {
    window.sessionStorage.setItem(bypassKey(orgId), "true");
  } catch {
    // Without sessionStorage the ToS screen is simply shown again.
  }
};

/** Removes every org's bypass (e.g. on sign-out), leaving unrelated sessionStorage keys untouched. */
export const clearTosViewBypasses = (): void => {
  try {
    const storage = window.sessionStorage;
    // Iterate in reverse so removals do not shift the indices still to visit.
    for (let index = storage.length - 1; index >= 0; index--) {
      const key = storage.key(index);
      if (key?.startsWith(TOS_BYPASS_KEY_PREFIX)) {
        storage.removeItem(key);
      }
    }
  } catch {
    // Nothing to clear when sessionStorage is unavailable.
  }
};
